import React from 'react';
import Gleap from 'gleap';
import { timeAgo } from '@/utils/ts/stringUtils';

import RightArrow from '@/components/Icons/icons/RightArrow';
import ButtonComponent from '../../ButtonComponent/ButtonComponent';

export default function SathiMigrationInterruptedNotification({
  notification,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}) {
  const handleAction = () => {
    markSingleNotificationAsSeen();
    setShowNotificationDropdown(null);
    Gleap.startConversation();
  };

  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div">⚠️</div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">Couldn&apos;t complete migration</h3>
        <p className="description">
          We couldn&apos;t move your ambassadors to SATHI.
        </p>
        <div className="mt-2">
          <ButtonComponent
            variant="text-highlight"
            style={{ padding: '0px' }}
            textStyle={{ fontSize: '14px' }}
            onClick={handleAction}
            rightIcon={<RightArrow color="var(--text-highlight)" />}>
            Contact Support
          </ButtonComponent>
        </div>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
